import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { CutterProfileModuleModel } from '@models/types'

import camelCaseToTitleCase from '@functions/utils/camelCaseToTitleCase'

import useCutterProfileModule from '@hooks/useCutterProfileModule'

interface CutterProfileModuleListItemProps {
  cutterProfileModule: CutterProfileModuleModel,
}

const CutterProfileModuleListItem = (props: CutterProfileModuleListItemProps) => {
  const {
    cutterProfileModule,
    cutterProfileModule: {
      height,
      name,
      width,
      adTypeId,
    },
  } = props

  const {
    callbacks: {
      createOrEditCutterProfileModule,
    },
  } = useCutterProfileModule(cutterProfileModule)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditCutterProfileModule()}
      secondaryText={camelCaseToTitleCase(adTypeId)}
      title={name}
    >
      <DashboardModuleListItem.TertiaryText>
        {`${width} by ${height}`}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CutterProfileModuleListItem
